export default function ExternalRoutes({ children }) {
  return (
    <>
      {children}
    </>
  );
}
